import { SegmentAnalytics } from './segment'

const analytics = new SegmentAnalytics(window._env_.segmentId)

export { analytics }
